import { render, staticRenderFns } from "./pageBottom.vue?vue&type=template&id=348b73da&scoped=true"
import script from "./pageBottom.vue?vue&type=script&lang=js"
export * from "./pageBottom.vue?vue&type=script&lang=js"
import style0 from "./pageBottom.vue?vue&type=style&index=0&id=348b73da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b73da",
  null
  
)

export default component.exports